import axios, { AxiosPromise } from 'axios';
import { ISchool, IGetSchool, IGetSchools, ISchoolParams, IGetSchoolRecords, ISchoolRecord } from '../models/schools.model';

const uri = '/mgmt/schools';

export const getSchools = (params?: ISchoolParams): AxiosPromise<IGetSchools> => {
  return axios.get(uri, { params });
};

export const getSchool = (schoolCode: string): AxiosPromise<IGetSchool> => {
  return axios.get(`${uri}/${schoolCode}`);
};

export const createSchool = (req: ISchool): AxiosPromise => {
  return axios.post(uri, req);
};

export const updateSchool = (schoolCode: string, req: ISchool): AxiosPromise => {
  return axios.put(`${uri}/${schoolCode}`, req);
};

export const deleteSchool = (schoolCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${schoolCode}`);
};

export const getSchoolRecords = (memberCode: string): AxiosPromise<IGetSchoolRecords> => {
  return axios.get(`${uri}/score/${memberCode}`);
};

export const postSchoolRecords = (memberCode: string, req: ISchoolRecord[]): AxiosPromise => {
  return axios.post(`${uri}/score/${memberCode}`, req);
};